import utils from '@/utils';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	getUseYnList: ({ plantCd, commCdType }) => {
		return client
			.post(`${BASE_URL}/cc/v1/plants/${plantCd}/commonCodes?commCdType=${commCdType}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	select: ({ useYn, params, currentPage, pageUnit }) => {
		const queryParams = utils.objectToQueryString({ ...params, currentPage, pageUnit });
		return client
			.get(`${BASE_URL}/widgetMaster/v1/useYn/${useYn}${queryParams}`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	save: ({ params }) => {
		return client
			.post(`${BASE_URL}/widgetMaster/v1/save`, params)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	},

	delete: ({ params }) => {
		return client
			.post(`${BASE_URL}/widgetMaster/v1/delete`, params)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error;
			});
	}

	// selectWidgetMasterList: (useYn, params) =>
	// 	client.get(`${BASE_URL}/widgetMaster/v1/useYn/${useYn}` + toQueryParams(params)).then(r => r.data),

	// delete: body => client.post(`${BASE_URL}/widgetMaster/v1/delete`, body).then(res => res.data)

	// save: body => client.post(`${BASE_URL}/widgetMaster/v1/save`, body).then(res => res.data)
};
